export default function (price: number): number | string {
  if (typeof price === 'undefined' || price === null) {
    return ''
  }

  return price.toFixed(2)
}
